// extracted by mini-css-extract-plugin
export default {"component":"checklistRoot__component___20F8E"};